"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HamburgerMenu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = require("./Button");

var _atoms = require("../atoms");

var _names = require("../formaters/names");

var _Util = require("../Util");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HamburgerMenu = function HamburgerMenu(_ref) {
  var open = _ref.open,
      children = _ref.children,
      user = _ref.user,
      onClose = _ref.onClose,
      signIn = _ref.signIn,
      signOut = _ref.signOut,
      team = _ref.team,
      utmCampaign = _ref.utmCampaign,
      utmSource = _ref.utmSource,
      utmMedium = _ref.utmMedium,
      accountUrl = _ref.accountUrl,
      settingsUrl = _ref.settingsUrl,
      traceGoDomain = _ref.traceGoDomain,
      traceLbDomain = _ref.traceLbDomain,
      traceIdDomain = _ref.traceIdDomain;
  var cn = "HamburgerMenu";

  var _useState = (0, _react.useState)(open),
      _useState2 = _slicedToArray(_useState, 2),
      wasOpen = _useState2[0],
      setWasOpen = _useState2[1];

  var handleEsc = function handleEsc(e) {
    var el = document.querySelector('.HamburgerMenu.open');

    if (el && e.keyCode === 27 && onClose) {
      onClose();
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('keyup', handleEsc);
    return function () {
      document.removeEventListener('keypress', handleEsc);
      (0, _Util.removeClassName)(document.body, 'locked');
    };
  }, []);

  if (open) {
    cn += ' open';

    if (wasOpen !== open) {
      setWasOpen(open);
    }
  } else {
    if (wasOpen) {
      cn += ' closed';
      setTimeout(function () {
        setWasOpen(false);
        (0, _Util.removeClassName)(document.body, 'locked');
      }, 600);
    }
  }

  if (open || wasOpen) {
    (0, _Util.addClassName)(document.body, 'locked');
  }

  var goDomain = traceGoDomain ? traceGoDomain : "https://go.traceup.com";
  var idDomain = traceIdDomain ? traceIdDomain : "https://id.traceup.com";
  var lbDomain = traceLbDomain ? traceLbDomain : "https://go.traceup.com";
  var year = new Date().getFullYear();
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: cn,
    trkContext: "Hamburger Menu"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "Shade",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "HamburgerMenuInner"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    trkAction: "Close Menu",
    icon: _atoms.Icon.Type.Close,
    marginLeft: "5",
    marginRight: "4",
    marginTop: "6",
    marginBottom: "5",
    onClick: function onClick() {
      return onClose();
    }
  }), team && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    marginLeft: "8",
    marginRight: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading4,
    marginTop: "2",
    marginBottom: "2",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Element, null, team.title)
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-act": "Games Pressed",
      href: "/#/".concat(team.name)
    }, "Games")
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-act": "Roster Pressed",
      href: "/#/".concat(team.name, "/rosters/season/").concat(year)
    }, "Roster")
  }), settingsUrl && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    trkAction: "Settings Pressed",
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: settingsUrl
    }, "Settings")
  }), accountUrl && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      "data-trk-act": "Account Pressed",
      to: accountUrl
    }, "Account")
  }), /*#__PURE__*/_react.default.createElement("hr", {
    className: "more-line"
  })), user && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    marginLeft: "8",
    marginRight: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading4,
    marginTop: "2",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Element, null, (0, _names.formatFullName)(user))
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.body,
    marginBottom: "2",
    content: user.email,
    color: _atoms.Color.Grey1,
    small: true
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-act": "My Teams Pressed",
      href: "/#/"
    }, "My Teams")
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-act": "My Trace ID Pressed",
      href: "".concat(idDomain, "/find/user/").concat(user.user_id)
    }, "My Trace iD")
  }), /*#__PURE__*/_react.default.createElement("hr", {
    className: "more-line"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    marginLeft: "8",
    marginRight: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-act": "Leaderboards Pressed",
      href: "/leader/boards"
    }, "Leaderboards")
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-action": "Academy Pressed",
      href: "https://traceup.com/soccer/academy",
      target: "_blank"
    }, "Academy")
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      "data-trk-act": "Help Pressed",
      href: "https://traceup.com/soccer/help",
      target: "_blank"
    }, "Help center")
  }), user && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    trkAction: "Signout Pressed",
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: signOut,
    color: _atoms.Color.Trace,
    content: "Sign out",
    touchable: true
  }), !user && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    trkAction: "Signin Pressed",
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: signIn,
    color: _atoms.Color.Trace,
    content: "Sign in",
    touchable: true
  }), user && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    marginTop: "2",
    marginBottom: "2",
    onClick: function onClick() {
      return onClose();
    },
    content: /*#__PURE__*/_react.default.createElement("a", {
      href: "https://traceup.com/refer?utm_source=go&utm_medium=webapp&utm_campaign=refs&referred_by=".concat(user && user.email ? user.email : ''),
      target: "_blank",
      rel: "noopener noreferer",
      "data-trk": "main:Refer Friend:Referal Button"
    }, "Refer a team. Get $100")
  }), children)));
};

exports.HamburgerMenu = HamburgerMenu;
HamburgerMenu.protoTypes = {
  /* Will open or close Hamburger menu */
  open: _propTypes.default.bool,

  /* Logged in user, used to show full name, and Signed in/out buttons */
  user: _propTypes.default.object,

  /* Function to be called on Sign in */
  signIn: _propTypes.default.func,

  /* Function to be called on Sign out */
  signOut: _propTypes.default.func,

  /* Used to show user's team selected, and to construct appropriate Team related URLs */
  team: _propTypes.default.object,

  /* UTM code */
  utmCampaign: _propTypes.default.string,

  /* UTM code */
  utmSource: _propTypes.default.string,

  /* UTM code */
  utmMedium: _propTypes.default.string
};